import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button, Container, Card } from "react-bootstrap";
import { getLead, deleteLead } from "../../store/slices/leads";
import DeleteModal from "./deletepopup";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash,FaEye } from "react-icons/fa";

export default function Leads() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { leadList = [] } = useSelector((state) => state.lead);

  useEffect(() => {
    dispatch(getLead());
  }, [dispatch]);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deleteLead(selectedId)).unwrap();

      setDeleteStatus("success");
      setCurrentPage(1);

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  const totalPages = Math.ceil(leadList.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentLeads = leadList.slice(indexOfFirstItem, indexOfLastItem);

  const changePage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/hotel/lead")}
          >
            Lead
          </span>
        </div>

        <Button
          className="add-outlet-btn"
          onClick={() => navigate("/hotel/addlead")}
        >
          + Add Lead
        </Button>
      </div>
      <Container fluid>
        <Card className="table-border">
          <Card.Body>
            <div className="guests-table-wrapper common-table-wrapper">
              <table className="table guests-table common-table align-middle">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Name</th>
                    <th className="text-center">Email</th>
                    <th className="text-center">Mobile Number</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {leadList?.length > 0 ? (
                    currentLeads.map((lead, index) => (
                      <tr key={lead._id}>
                        <td className="text-center">
                          {indexOfFirstItem + index + 1}
                        </td>

                        <td className="text-center">{lead.name}</td>

                        <td className="text-center">{lead.email}</td>

                        <td className="text-center">{lead.phone}</td>

                        <td className="text-center">
                          <div className="action-btn-group d-flex justify-content-center gap-2">
                            <button
                              onClick={() =>
                                navigate(`/hotel/leaddetails/${lead._id}`)
                              }
                              className="action-btn edit-btn"
                            >
                              <FaEye size={14} />
                            </button>
                            {/* Edit */}
                            <button
                              onClick={() =>
                                navigate(`/hotel/editlead/${lead._id}`)
                              }
                              className="action-btn edit-btn"
                            >
                              <FaEdit size={14} />
                            </button>

                            {/* Delete */}
                            <button
                              className="action-btn delete-btn"
                              onClick={() => {
                                setSelectedId(lead._id);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-muted py-4">
                        No Leads Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3 gap-2">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="previous-btn"
                >
                  Prev
                </Button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    size="sm"
                    variant={
                      currentPage === i + 1 ? "primary" : "outline-secondary"
                    }
                    onClick={() => changePage(i + 1)}
                    className={`button-between ${currentPage === i + 1 ? "active-page" : ""
                      }`}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="next-btn"
                >
                  Next
                </button>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
